import { Experience, Importance } from "PFTypes";

import { IsoDate } from "./date_time";
import { Id } from "./id";

export enum SkillsFrameworkRank {
  Primary = "primary",
  Secondary = "secondary"
}

export enum CustomTypeMatchingCriteria {
  And = "matching_all",
  Or = "matching_any"
}

export const SkillsFrameworkRanks = Object.values(SkillsFrameworkRank);

export type SkillsFrameworkCustomValue = {
  id: Id;
  customValueId: Id;
  value: string;
  created?: boolean;
};

export type SkillsFrameworkSkill = {
  id: Id;
  skillId: Id;
  importance: Importance;
  requiredExperience: Experience;
  value: string;
  proposed: boolean;
  tagIds: Id[];
  created?: boolean;
};

export type SkillsFramework<CFValue = SkillsFrameworkCustomValue, SValue = SkillsFrameworkSkill> = {
  id: Id;
  name: string;
  description?: string;
  availableInDemand?: boolean;
  skillsFrameworkCustomTypes: {
    id: Id;
    customTypeId: Id;
    name: string;
    displayAs: string;
    matchingCriteria: CustomTypeMatchingCriteria;
    skillsFrameworkCustomValues: CFValue[];
  }[];
  skills: SValue[];
  activeProfilesCount?: number;
  skillsCount?: number;
  rank: SkillsFrameworkRank;
  coverage: number;
  updatedAt: IsoDate;
};

export type SkillsFrameworkCreateUpdateData = {
  name: string;
  description?: string;
  availableInDemand?: boolean;
  skillsFrameworkCustomTypes: {
    customTypeId: Id;
    matchingCriteria: CustomTypeMatchingCriteria;
    skillsFrameworkCustomValuesAttributes: Pick<SkillsFrameworkCustomValue, "customValueId">[];
  }[];
  skills: {
    skillId: Id;
    importance: Importance;
    requiredExperience: Experience;
  }[];
  rank: SkillsFrameworkRank;
};
